<template>
    <div class="max-w-sm p-8 border border-gray-300 shadow">
        <header v-if="$slots.title" class="mb-6 text-lg font-semibold">
            <slot name="title"></slot>
        </header>
        <main class="text-sm leading-tight">
            <slot></slot>
        </main>
    </div>
</template>
